/* eslint-disable no-unused-vars */
const ErrorFallback = ({ error, resetErrorBoundary }) => <div />;

export default ErrorFallback;
